import React from "react";
import { Avatar, Box, Grid, Heading, Paragraph, ResponsiveContext } from "grommet";
import moment from "moment";
export var CalendarEventCardSecondOption = function CalendarEventCardSecondOption(_ref) {
  var events = _ref.events,
    image = _ref.image,
    selectedMonth = _ref.selectedMonth;
  var date = selectedMonth.value;
  var activeEvents = events;

  if (date) {
    activeEvents = events.filter(function (event) {
      var eventStart = moment(event.start, "DD.MM.YYYY");
      var eventEnd = moment(event.end, "DD.MM.YYYY");
      return eventStart.isSame(date, "M") && !eventEnd.isBefore(moment(), "D");
    });
  }

  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Grid,
        {
          columns: {
            count: "fill",
            size: "330px",
          },
          justify: "center",
          gap: "medium",
        },
        activeEvents.map(function (event) {
          return /*#__PURE__*/ React.createElement(
            Box,
            {
              width: "330px",
              height: "330px",
              round: "20px",
              background: {
                color: "site-colors-1",
              },
              margin: {
                bottom: "medium",
              },
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                direction: "row",
              },
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  flex: true,
                  direction: "row",
                  justify: "between",
                  color: "light",
                },
                /*#__PURE__*/ React.createElement(
                  Box,
                  {
                    pad: {
                      top: "32px",
                      left: "medium",
                    },
                  },
                  /*#__PURE__*/ React.createElement(
                    Heading,
                    {
                      level: 5,
                      style: {
                        textTransform: "uppercase",
                      },
                    },
                    event.start
                  ),
                  /*#__PURE__*/ React.createElement(
                    Paragraph,
                    {
                      size: "small",
                      style: {
                        fontWeight: "bolder",
                      },
                    },
                    event.address
                  )
                )
              ),
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  pad: "13px",
                },
                /*#__PURE__*/ React.createElement(Avatar, {
                  src: image,
                  size: "43px",
                })
              )
            ),
            /*#__PURE__*/ React.createElement(
              Box,
              {
                flex: true,
                gap: "xlarge",
                pad: {
                  vertical: "32px",
                  horizontal: "medium",
                },
                color: "light",
              },
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  flex: true,
                  justify: "end",
                },
                /*#__PURE__*/ React.createElement(
                  Box,
                  {
                    gap: "xxsmall",
                  },
                  /*#__PURE__*/ React.createElement(
                    Heading,
                    {
                      level: 4,
                      style: {
                        color: "#e21a25",
                      },
                    },
                    event.headline
                  ),
                  /*#__PURE__*/ React.createElement(
                    Paragraph,
                    {
                      size: "0.75rem",
                      style: {
                        lineHeight: "16px",
                        color: "#e21a25",
                      },
                    },
                    event.subtitle
                  )
                )
              )
            )
          );
        })
      );
    })
  );
};
